import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-public-sector",
  templateUrl: "./public-sector.component.html",
  styleUrls: ["./public-sector.component.scss"],
})
export class PublicSectorComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
